import type { TranslationDict } from '../en';

const th: TranslationDict = {
  'header.buy': 'ซื้อ',
  'header.sell': 'ขาย',
  'spend.label': 'คุณจ่าย',
  'spend.placeholderFiat': '250',
  'spend.placeholderCrypto': '0.01',
  'receive.label': 'คุณได้รับ',
  'payment.label': 'วิธีการชำระเงิน',
  'payment.select': 'เลือก',
  'provider.label': 'By',
  'provider.select': 'Select',
  'provider.unavailable': 'Unavailable',
  'provider.unavailablePayment': 'Payment method not supported',
  'provider.unavailableCountry': 'Region not supported',
  'provider.unavailableCurrency': 'Currency not supported',
  'provider.unavailableNetwork': 'Network not supported',
  'payment.noneAvailable': 'ไม่มีวิธีการชำระเงินสำหรับคู่นี้',
  'wallet.label': 'ที่อยู่กระเป๋าเงินรับ',
  'wallet.placeholderBuy': 'กรอกที่อยู่กระเป๋าเงินรับของคุณ',
  'wallet.placeholderSell': 'กรอกที่อยู่กระเป๋าเงินส่งของคุณ',
  'wallet.validating': 'กำลังตรวจสอบที่อยู่...',
  'wallet.invalid': 'กรุณากรอกที่อยู่กระเป๋าเงินที่ถูกต้อง',
  'wallet.invalidServer': 'ที่อยู่กระเป๋าเงินไม่ถูกต้อง',
  'cta.buy': 'ซื้อ {crypto}',
  'cta.sell': 'ขาย {crypto}',
  'cta.gettingPrice': 'กำลังหาราคาที่ดีที่สุด...',
  'cta.processing': 'กำลังดำเนินการ...',
  'footer.poweredBy': 'ขับเคลื่อนโดย ',
  'footer.brand': 'NowRamp',
  'rate.title': 'รายละเอียดอัตราแลกเปลี่ยน',
  'rate.close': 'ปิด',
  'rate.updatesIn': 'อัตราจะอัปเดตใน 00:{seconds}',
  'rate.noQuote': 'ไม่มีใบเสนอราคา',
  'rate.exchangeRate': 'อัตราแลกเปลี่ยน',
  'rate.processingFee': 'ค่าธรรมเนียมการดำเนินการ',
  'rate.networkFee': 'ค่าธรรมเนียมเครือข่าย',
  'rate.provider': 'ผู้ให้บริการ',
  'toast.orderCreated': 'สร้างคำสั่งแล้ว',
  'toast.redirecting': 'กำลังเปลี่ยนเส้นทางไปยังการชำระเงิน...',
  'toast.orderFailed': 'คำสั่งล้มเหลว',
  'toast.couldNotCreate': 'ไม่สามารถสร้างคำสั่งได้',
  'toast.quoteError': 'ข้อผิดพลาดของใบเสนอราคา',
  'toast.noProviders': 'ไม่มีผู้ให้บริการ',
  'toast.somethingWrong': 'เกิดข้อผิดพลาด',
  'error.amountZero': 'จำนวนเงินต้องมากกว่า 0',
  'error.minAmountFiat': 'จำนวนเงินขั้นต่ำคือ {min} {currency}',
  'error.minAmountCrypto': 'จำนวนเงินขั้นต่ำคือ {min} {currency}',
  'error.noProviders': 'ไม่มีผู้ให้บริการสำหรับชุดค่าผสมนี้',
  'error.currencyUnavailableBuy': 'สกุลเงินนี้ไม่สามารถใช้สำหรับคำสั่งซื้อได้',
  'error.currencyUnavailableSell': 'สกุลเงินนี้ไม่สามารถใช้สำหรับคำสั่งขายได้',
  'parity.info': 'คุณจะถูกเรียกเก็บเงินสำหรับ {receiveAmount} {crypto} ส่วนที่เหลือจนถึง {spendAmount} {fiat} จะถูกเครดิตเข้าบัญชี {partner} ของคุณ',
  'redirect.secureBadge': 'การชำระเงินที่ปลอดภัย',
  'redirect.title': 'ดำเนินการชำระเงินต่อ',
  'redirect.description': 'คุณจะถูกเปลี่ยนเส้นทางไปยัง {gateway} เพื่อดำเนินการชำระเงินให้เสร็จสิ้น',
  'redirect.countdown': 'กำลังเปลี่ยนเส้นทางใน {seconds}...',
  'redirect.openTab': 'เปิด ACH ในแท็บใหม่',
  'redirect.cancel': 'ยกเลิก',
  'checkout.noOrder': 'ไม่พบคำสั่ง',
  'checkout.goBack': 'ย้อนกลับ',
  'checkout.expired': 'เซสชันหมดอายุ',
  'checkout.expiredDesc': 'เซสชันหมดอายุแล้ว กรุณาลองอีกครั้ง',
  'checkout.startOver': 'เริ่มใหม่',
  'checkout.cancel': 'ยกเลิก',
  'checkout.loading': 'กำลังโหลดการชำระเงิน...',
  'checkout.iframeTitle': 'การชำระเงินของผู้ให้บริการ',
  'checkout.widgetTitle': 'การชำระเงิน',
  'checkout.unknownMethod': 'วิธีการชำระเงินที่ไม่รู้จัก',
  'processing.default': 'กำลังดำเนินการคำสั่งของคุณ...',
  'processing.pending': 'กำลังรอการยืนยันการชำระเงิน...',
  'processing.active': 'กำลังดำเนินการธุรกรรมของคุณ...',
  'processing.generic': 'กำลังดำเนินการ...',
  'processing.checkingStatus': 'กำลังตรวจสอบสถานะ...',
  'processing.orderId': 'รหัสคำสั่ง',
  'processing.provider': 'ผู้ให้บริการ',
  'processing.amount': 'จำนวนเงิน',
  'processing.receiving': 'กำลังรับ',
  'processing.network': 'เครือข่าย',
  'processing.toAddress': 'ที่อยู่ปลายทาง',
  'processing.usuallyMinutes': 'โดยปกติจะใช้เวลาสักครู่',
  'processing.safeToClose': 'คุณสามารถปิดหน้านี้ได้อย่างปลอดภัย — เราจะส่งอีเมลเมื่อเสร็จสิ้น',
  'complete.buyTitle': 'การซื้อสำเร็จ!',
  'complete.sellTitle': 'การขายสำเร็จ!',
  'complete.buyDesc': '{crypto} ของคุณถูกส่งไปยังกระเป๋าเงินแล้ว',
  'complete.sellDesc': 'การจ่ายเงิน {fiat} ของคุณกำลังดำเนินการ',
  'complete.amountBuy': 'จำนวนที่ได้รับ',
  'complete.amountSell': 'จำนวนที่ขาย',
  'complete.paidBuy': 'จำนวนที่จ่าย',
  'complete.paidSell': 'จำนวนเงินจ่าย',
  'complete.network': 'เครือข่าย',
  'complete.wallet': 'กระเป๋าเงิน',
  'complete.transaction': 'ธุรกรรม',
  'complete.provider': 'ผู้ให้บริการ',
  'complete.orderId': 'รหัสคำสั่ง',
  'complete.completed': 'เสร็จสมบูรณ์',
  'complete.viewExplorer': 'ดูบน Explorer',
  'complete.done': 'เสร็จสิ้น',
  'errorStep.failed': 'การชำระเงินล้มเหลว',
  'errorStep.cancelled': 'คำสั่งถูกยกเลิก',
  'errorStep.expired': 'คำสั่งหมดอายุ',
  'errorStep.refunded': 'คำสั่งถูกคืนเงิน',
  'errorStep.unknown': 'เกิดข้อผิดพลาด',
  'errorStep.failedBuy': 'ไม่สามารถดำเนินการชำระเงินของคุณได้ กรุณาลองอีกครั้งหรือใช้วิธีการชำระเงินอื่น',
  'errorStep.failedSell': 'ไม่สามารถดำเนินการขายของคุณได้ กรุณาลองอีกครั้ง',
  'errorStep.cancelledBuy': 'คำสั่งของคุณถูกยกเลิก ไม่มีการชำระเงินใดถูกดำเนินการ',
  'errorStep.cancelledSell': 'การขายของคุณถูกยกเลิก ไม่มีคริปโตถูกโอน',
  'errorStep.expiredBuy': 'คำสั่งของคุณหมดอายุแล้ว กรุณาเริ่มการซื้อใหม่',
  'errorStep.expiredSell': 'คำสั่งของคุณหมดอายุแล้ว กรุณาเริ่มการขายใหม่',
  'errorStep.refundedBuy': 'การชำระเงินของคุณได้รับการคืนแล้ว เงินควรปรากฏในบัญชีของคุณภายใน 5-10 วันทำการ',
  'errorStep.refundedSell': 'คริปโตของคุณได้ถูกส่งคืนแล้ว เงินควรปรากฏในกระเป๋าเงินของคุณในไม่ช้า',
  'errorStep.genericDesc': 'เกิดข้อผิดพลาดที่ไม่คาดคิด กรุณาลองอีกครั้ง',
  'errorStep.orderId': 'รหัสคำสั่ง',
  'errorStep.tryAgain': 'ลองอีกครั้ง',
  'errorStep.startOver': 'เริ่มใหม่',
  'errorStep.return': 'กลับ',
  'errorStep.needHelp': 'ต้องการความช่วยเหลือ? ติดต่อ ',
  'errorStep.reference': 'อ้างอิง: {orderId}',
  'confirm.buyTitle': 'ยืนยันการซื้อ',
  'confirm.sellTitle': 'ยืนยันการขาย',
  'confirm.loading': 'กำลังโหลด...',
  'confirm.provider': 'ผู้ให้บริการ',
  'confirm.youPay': 'คุณจ่าย',
  'confirm.youSell': 'คุณขาย',
  'confirm.youReceive': 'คุณได้รับ',
  'confirm.wallet': 'กระเป๋าเงิน',
  'confirm.network': 'เครือข่าย',
  'confirm.refundAddress': 'ที่อยู่สำหรับคืนเงิน',
  'confirm.parityNote': 'จำนวนเงินที่เรียกเก็บจากผู้ให้บริการอาจแตกต่างกัน ส่วนที่เหลือจนถึง {amount} {crypto} จะถูกเครดิตเข้าบัญชี {partner} ของคุณ',
  'confirm.processing': 'กำลังดำเนินการ...',
  'confirm.confirmPay': 'ยืนยันและชำระเงิน',
  'confirm.confirmSell': 'ยืนยันและขาย',
  'confirm.payout': 'การจ่ายเงิน {currency}',
  'modal.selectFiat': 'เลือกสกุลเงินเฟียต',
  'modal.selectCrypto': 'เลือกสกุลเงินคริปโต',
  'modal.choosePayment': 'เลือกวิธีการชำระเงิน',
  'modal.selectCountry': 'เลือกประเทศของคุณ',
  'modal.selectLanguage': 'Select language',
  'modal.popular': 'ยอดนิยม',
  'modal.recommended': 'แนะนำ',
  'modal.noCurrencies': 'ไม่พบสกุลเงิน',
  'modal.noPaymentMethods': 'ไม่พบวิธีการชำระเงิน',
  'modal.noCountries': 'ไม่พบประเทศ',
  'modal.noLanguages': 'No languages found',
  'settings.location': 'ตำแหน่งที่ตั้ง',
  'settings.darkMode': 'โหมดมืด',
  'settings.privacy': 'นโยบายความเป็นส่วนตัว',
  'settings.terms': 'ข้อกำหนดการใช้งาน',
  'settings.language': 'ภาษา',
  // ─── Additional ───
  'modal.chooseRamp': 'เลือก Ramp',
  'modal.bestPrice': 'ราคาที่ดีที่สุด',
  'modal.noQuotes': 'ไม่มีใบเสนอราคาสำหรับคำขอนี้',
  'modal.noProvidersFound': 'ไม่พบผู้ให้บริการ',
  'payment.unavailableFor': 'ไม่มีวิธีการชำระเงินสำหรับ {currency}',
  'skeleton.poweredBy': 'ขับเคลื่อนโดย NowRamp',
  'error.createOrderFailed': 'ไม่สามารถสร้างคำสั่งได้',
  'errorStep.returnToMerchant': 'กลับไปยังร้านค้า',
  'confirm.cryptoOnNetwork': '{crypto} บน {network}',
  'payment.name.card': 'บัตร',
  'payment.name.bankTransfer': 'โอนเงินธนาคาร',
  'payment.name.ach': 'ACH',
  'rate.updatesInLabel': 'Rate updates in',
  'rate.networkFeeIncl': 'Network fee incl.',
  'rate.rateTooltip': 'As the market is highly volatile, we can fix the exchange rate for no longer than 30 seconds.',
  'rate.networkFeeTooltip': 'Includes a fee charged by blockchain to execute the transaction.',
  'rate.feeIncluded': '{percentage}% incl.',
  'receive.fetchingRate': 'Fetching best rate...',
  'redirect.tabHelper': 'If the new tab has not opened, click the button above.',
};

export default th;
